<template>
  <div class="navbar">
    <dv-border-box-11 title="基础信息">
      <dv-decoration-3 />

      <dv-decoration-7 class="totalQty">库存总量</dv-decoration-7>
      <dv-decoration-7 class="safaQty">安全总量</dv-decoration-7>
      <dv-decoration-9 class="safaQty9">10000</dv-decoration-9>
      <dv-decoration-9 class="totalQty9">999</dv-decoration-9>
      <dv-decoration-2 />
      <dv-decoration-7 class="top10Qty">库存TOP10分布图</dv-decoration-7>
      <dv-capsule-chart :config="configtop10" />
      <dv-decoration-2 class="pullPlan" />

      <dv-decoration-7 class="pullPlan7">呼叫物料清单</dv-decoration-7>
      <dv-scroll-board :config="configPullData" />
    </dv-border-box-11>
  </div>
</template>

<script>
export default {
  name: "AppNavbar",
  data() {
    return {
      configtop10: {
        data: [
          {
            name: "南阳",
            value: 167,
          },
          {
            name: "周口",
            value: 123,
          },
          {
            name: "漯河",
            value: 98,
          },
          {
            name: "郑州",
            value: 75,
          },
          {
            name: "西峡",
            value: 66,
          },
          {
            name: "南阳1",
            value: 167,
          },
          {
            name: "周口1",
            value: 123,
          },
          {
            name: "漯河1",
            value: 98,
          },
          {
            name: "郑州1",
            value: 75,
          },
          {
            name: "西峡1",
            value: 66,
          },
        ],
        colors: [
          "#e062ae",
          "#fb7293",
          "#e690d1",
          "#32c5e9",
          "#96bfff",
          "#fb7293",
          "#e690d1",
          "#32c5e9",
          "#96bfff",
          "#96bfff",
        ],
        unit: "箱",
        showValue: true,
      },
      configPullData: {
        header: ["列1", "列2", "列3"],
        data: [
          ['<span style="color:#37a2da;">行1列1</span>', "行1列2", "行1列3"],
          ["行2列1", '<span style="color:#32c5e9;">行2列2</span>', "行2列3"],
          ["行3列1", "行3列2", '<span style="color:#67e0e3;">行3列3</span>'],
          ["行4列1", '<span style="color:#9fe6b8;">行4列2</span>', "行4列3"],
          ['<span style="color:#ffdb5c;">行5列1</span>', "行5列2", "行5列3"],
          ["行6列1", '<span style="color:#ff9f7f;">行6列2</span>', "行6列3"],
          ["行7列1", "行7列2", '<span style="color:#fb7293;">行7列3</span>'],
          ["行8列1", '<span style="color:#e062ae;">行8列2</span>', "行8列3"],
          ['<span style="color:#e690d1;">行9列1</span>', "行9列2", "行9列3"],
          ["行10列1", '<span style="color:#e7bcf3;">行10列2</span>', "行10列3"],
        ],
        index: true,
        columnWidth: [50],
        align: ["center"],
      },
    };
  },
};
</script>
 
<style    scoped>
.dv-decoration-3 {
  width: 100%;
  height: 2%;
  top: 7%;
  position: absolute;
}
.totalQty {
  left: 6%;
  top: 10%;
}
.safaQty {
  left: 51%;
  top: 10%;
}
.dv-decoration-9 {
  width: 30%;
  height: 10%;
  top: 14%;
  position: absolute;
  color: white;
}

.safaQty9 {
  left: 55%;
    width: 30%;
}
.totalQty9 {
  left: 10%;
  width: 30%;
}
.dv-decoration-2 {
  position: absolute;
  top: 28%;
  left: 2%;
  width: 90%;
  height: 1%;
}
.dv-decoration-7 {
  position: absolute;
  width: 35%;
  height: 2%;
  color: rgb(3, 232, 248);

  font-size: 200;
}
.top10Qty {
  top: 25%;
  left: 10%;
  width: 70%;
}

.dv-capsule-chart {
  position: absolute;
  top: 29%;
  width: 90%;
  height: 30%;
  left: 3%;
}
.pullPlan {
  top: 59%;
}
.pullPlan7 {
  top: 63%;
  left: 10%;
  width: 70%;
}
.dv-scroll-board {
  top: 68%;
  width: 90%;
  height: 30%;
  left: 4%;
}
</style>
 